const COLLAPSED_SIZE = 37;
const LARGE_SCREEN = "lg";

export { COLLAPSED_SIZE, LARGE_SCREEN };
//# sourceMappingURL=constants.js.map
